export const STAGING_FIREBASE_CONFIG = {
  apiKey: "AIzaSyBDBpZHhsj_yKJvaSRKV18NmTZPLlvAoYU",
  authDomain: "mcc-staging-4525c.firebaseapp.com",
  projectId: "mcc-staging-4525c",
  storageBucket: "mcc-staging-4525c.appspot.com",
  messagingSenderId: "997610486361",
  appId: "1:997610486361:web:caa4947da5844492d6cf48",
  measurementId: "G-XCRZND4F6Q",
};

export const PRODUCTION_FIREBASE_CONFIG = {
  apiKey: "AIzaSyCOecC0c7UOkJKJjrWrxryLgtkUbdF_AGE",
  authDomain: "bigtimerun-4c245.firebaseapp.com",
  projectId: "bigtimerun-4c245",
  storageBucket: "bigtimerun-4c245.appspot.com",
  messagingSenderId: "129725470599",
  appId: "1:129725470599:web:bba45fce8830bc497f6522",
  measurementId: "G-ZMS089HQZP",
};

export function getFirebaseConfig(locationObject = window.location) {
  if (
    locationObject.origin === "https://mcc-staging-4525c.web.app" ||
    locationObject.origin === "http://localhost:3000" ||
    locationObject.port === "3000"
  ) {
    return STAGING_FIREBASE_CONFIG;
  }

  return PRODUCTION_FIREBASE_CONFIG;
}

// The app's existing Google Maps integrations use the production web key in all environments.
export const mapsApiKey = PRODUCTION_FIREBASE_CONFIG.apiKey;
export const mapsRegion = "CA";
